import { Dictionary } from '@ngrx/entity'
import { createFeatureSelector, createSelector } from '@ngrx/store'

import { EmployeeContractManagerLink } from './employee-contract-manager-link'
import * as fromEmployeeContractManagerLink from './employee-contract-manager-link.reducer'

const state =
  createFeatureSelector<fromEmployeeContractManagerLink.EmployeeContractManagerLinkState>(
    fromEmployeeContractManagerLink.FEATURE_NAME
  )

const adapter = fromEmployeeContractManagerLink.adapter.getSelectors()

const selectIds = createSelector(state, adapter.selectIds)
const selectAll = createSelector(state, adapter.selectAll)
const selectEntities = createSelector(state, adapter.selectEntities)

const selectIsLoading = createSelector(state, (state) => state.isLoading)

const selectState = createSelector(state, (state) => state && state)

const selectById = createSelector(
  selectEntities,
  (entities: Dictionary<EmployeeContractManagerLink>, id: number) => {
    return entities[id]
  }
)

const selectByFilter = createSelector(
  selectAll,
  (
    entities: EmployeeContractManagerLink[],
    filter?: { field: string; value: string | number }
  ) => {
    if (filter) {
      return entities.filter((entity) => entity[filter.field] == filter.value)
    }

    return entities
  }
)

const selectCount = createSelector(
  selectAll,
  (entities) => entities && entities.length
)
const selectPaginationDetails = createSelector(
  state,
  (state) => state.paginationDetails
)

export const employeeContractManagerLinkSelectors = {
  selectState,
  selectIsLoading,
  selectById,
  selectIds,
  selectEntities,
  selectAll,
  selectByFilter,
  selectCount,
  selectPaginationDetails
}
